import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import css from './index.css'
import Button from '~/components/common/Button';
import {modalClose, modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
class PhoneSuccess extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className={css.popwrap}>
        <div className={css.title}>Phone Number Confirmed</div>
        <div className={css.message}>Your phone number has been confirmed.</div>
        <Button
          className={css.btn}
          mods={['large', 'action']}
          onClick={this.props.closePop}
        >OK</Button>
      </div>
    )
  }
}

export default connect(null, mapDispatch({
  closePop: () => modalClose(modes.PHONE_SUCCESS)
}))(PhoneSuccess);


// WEBPACK FOOTER //
// ./src/components/Popup/PhoneSuccess/index.js